import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import styled from "styled-components";
import { getPoems, getStories, getUserByName } from "./utilities/ApiCalls";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Search } from "lucide-react";
import Constant from "./Constant";
import ProfileImage from "../Componets/ProfileImage";

const SearchBar = () => {
  const [form, setForm] = useState({
    search_type: "story",
    search: "",
  });
  const [users, setusers] = useState([]);
  const [story, setstory] = useState([]);
  const [poem, setpoem] = useState([]);

  const history = useHistory();

  const proxiedUrl = (url) => {
    if (!url || url.includes("story-tent-testing.s3.ap-south-1.amazonaws.com"))
      return url;
    return `${Constant.apiBasePath}proxy-image?url=${encodeURIComponent(url)}`;
  };

  function onChangeForm(e) {
    setForm({
      ...form,
      [e.target.getAttribute("name")]: e.target.value,
    });
  }

  const HandleClick = (id) => {
    history.push(`/story-details/${id}`);
  };

  function onSubmitForm(e) {
    e.preventDefault();

    switch (form.search_type) {
      case "story":
        window.location.href = `/stories?search=${form.search}`;
        break;
      case "poem":
        window.location.href = `/poetries?search=${form.search}`;
        break;
      case "user":
        // window.location.href = `/user/searchUsersByName?name=${form.search}`;
        break;
      default:
        break;
    }
  }

  function getprofile() {
    getUserByName(form.search).then((response) => {
      setusers(response.data.data);
    });
  }

  function getHomePageStories() {
    let data = {};
    data.search = form.search;
    getStories(data).then((response) => {
      setstory(response.data);
    });
  }

  function getHomePagePoems() {
    let data = {};
    data.search = form.search;
    getPoems(data).then((response) => {
      setpoem(response.data);
    });
  }

  useEffect(() => {
    getprofile();
    getHomePageStories();
    getHomePagePoems();
  }, [form]);

  return (
    <Layout>
      <PageContainer>
        <SearchContainer>
          <Form onSubmit={onSubmitForm} onChange={onChangeForm}>
            <Select name="search_type" value={form.search_type}>
              <option value="story">Story</option>
              <option value="poem">Poem</option>
              <option value="user">User</option>
            </Select>
            <Input
              autoComplete="off"
              placeholder="Search..."
              name="search"
              value={form.search}
            />
            <SearchButton type="submit">
              <Search size={20} />
            </SearchButton>
          </Form>

          {form.search !== "" && (
            <ResultsContainer>
              {form.search_type === "user" && (
                <>
                  <ResultsGrid>
                    {users.slice(0, 6).map((data) => (
                      <ResultCard
                        key={data._id}
                        onClick={() => history.push(`/userprofile/${data._id}`)}
                      >
                        <ProfileImage
                          src={data?.profilePic}
                          name={data?.name}
                          size={40}
                          className="search-avatar"
                          alt={data.name}
                          proxiedUrl={proxiedUrl}
                          imgStyle={{
                            border: "2px solid var(--color-surface)",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                          }}
                        />
                        <CardContent>
                          <Title>{data.name}</Title>
                          <Subtitle>
                            @
                            {data.userName ||
                              data.name.toLowerCase().replace(/\s/g, "")}
                          </Subtitle>
                        </CardContent>
                      </ResultCard>
                    ))}
                  </ResultsGrid>
                  {users.length === 0 && <NoResults>No users found</NoResults>}
                </>
              )}

              {form.search_type === "story" && (
                <>
                  <ResultsGrid>
                    {story.slice(0, 6).map((data) => (
                      <ResultCard
                        key={data._id}
                        onClick={() => HandleClick(data._id)}
                      >
                        <Thumbnail src={data.thumbnail} alt={data.name} />
                        <CardContent>
                          <Title>{data.name}</Title>
                          <Subtitle>by {data.authorName}</Subtitle>
                        </CardContent>
                      </ResultCard>
                    ))}
                  </ResultsGrid>
                  {story.length === 0 && (
                    <NoResults>No stories found</NoResults>
                  )}
                </>
              )}

              {form.search_type === "poem" && (
                <>
                  <ResultsGrid>
                    {poem.slice(0, 6).map((data) => (
                      <ResultCard
                        key={data._id}
                        onClick={() =>
                          history.push(`/poem-details/${data._id}`)
                        }
                      >
                        <Thumbnail src={data.thumbnail} alt={data.name} />
                        <CardContent>
                          <Title>{data.name}</Title>
                          <Subtitle>by {data.authorName}</Subtitle>
                        </CardContent>
                      </ResultCard>
                    ))}
                  </ResultsGrid>
                  {poem.length === 0 && <NoResults>No poems found</NoResults>}
                </>
              )}

              {(users.length > 0 && form.search_type === "user") ||
              (story.length > 0 && form.search_type === "story") ||
              (poem.length > 0 && form.search_type === "poem") ? (
                <ViewMoreButton
                  onClick={() => {
                    if (form.search_type === "user") {
                      history.push(
                        `/user/searchUsersByName?name=${form.search}`
                      );
                    } else if (form.search_type === "story") {
                      history.push(`/stories?search=${form.search}`);
                    } else if (form.search_type === "poem") {
                      history.push(`/poetries?search=${form.search}`);
                    }
                  }}
                >
                  View More Results
                </ViewMoreButton>
              ) : null}
            </ResultsContainer>
          )}
        </SearchContainer>
      </PageContainer>
    </Layout>
  );
};

export default SearchBar;

// Styled Components
const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  /* background-color removed to let Layout grid show through */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 40px;
  position: relative;
  z-index: 1;
`;

const SearchContainer = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  z-index: 10;
`;

const Form = styled.form`
  display: flex;
  align-items: center;
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  height: 56px;
`;

const Select = styled.select`
  padding: 8px 12px;
  border: none;
  background-color: var(--color-background);
  color: var(--color-text);
  border-radius: 8px;
  outline: none;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer;
  height: 40px;
  border: 1px solid var(--color-border);

  &:focus {
    border-color: var(--color-primary);
  }

  option {
    background-color: var(--color-surface, #141f1e);
    color: var(--color-text, #ffffff);
    padding: 6px 10px;
  }
`;

const Input = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  color: var(--color-text);
  font-size: 16px;
  padding: 8px;
  outline: none;

  &::placeholder {
    color: var(--color-text-tertiary);
  }
`;

const SearchButton = styled.button`
  background: var(
    --color-surface
  ); /* Changed from primary to surface for better dark mode */
  color: var(--color-text);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: var(--color-background);
  }
`;

const ResultsContainer = styled.div`
  background-color: var(--color-surface);
  border-radius: 8px; /* Slightly larger than 6px for page context */
  border: 1px solid var(--color-border);
  overflow: hidden; /* Ensures shadows or backgrounds don't bleed */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); /* Optional: Keep page shadow or remove to be purely flat like modal */
  padding: 0; /* Remove padding to let list items touch edges */
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ResultsGrid = styled.div`
  display: flex;
  flex-direction: column;
  /* Removed gap to allow borders to be dividers */
`;

const ResultCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: transparent;
  border-bottom: 1px solid var(--color-border);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--color-background);
  }

  &:last-child {
    border-bottom: none;
  }
`;

const Thumbnail = styled.img`
  width: 40px; /* Match rounded avatar size context */
  height: 40px;
  border-radius: 8px; /* Slightly smaller radius for smaller size */
  object-fit: cover;
  border: 1px solid var(--color-border);
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Title = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Subtitle = styled.p`
  font-size: 12px;
  color: var(--color-text-tertiary);
  margin: 4px 0 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const NoResults = styled.div`
  text-align: center;
  padding: 20px;
  color: var(--color-text-tertiary);
`;

const ViewMoreButton = styled.button`
  width: calc(100% - 32px); /* Full width minus margins */
  margin: 16px; /* Spacing from list items and container edges */
  padding: 12px;
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: var(--color-background);
    border-color: var(--color-primary);
  }
`;
